import FormContainer from "@client/content/controls/Form/container";
import { getRootContainerProps } from "@client/content/lib/helper";
import api from "@client/content/modules/Checkout/api";
import { withOnSubmit } from "@client/content/modules/Checkout/hooks";
import { type FormFieldInfo, type FormHandles } from "@client/controls/Form/component";
import { type CreditCardInfo } from "@common/controls/Inputs/CreditCard/component";
import { validateCreditCard } from "@common/controls/Inputs/CreditCard/lib";
import * as React from "react";
import { type PaymentMethodBaseProps } from "../component";
import CreditCardInput, { type CreditCardInputProps } from "./CreditCard";

export type Props = PaymentMethodBaseProps & {};

const CheckoutPaymentAuthorizeNetCreditCard = (props: Props) => {
  const ref = withOnSubmit<FormHandles>((data) => {
    return {
      paymentInfo: {
        ...data,
        type: "AuthorizeNet"
      }
    };
  });

  const ccProps = React.useMemo(
    (): CreditCardInputProps => ({
      createPaymentIntent: async (creditCardInfo: CreditCardInfo) => {
        const res = await api.payment(props.apiInfo, {
          paymentMethodId: props.paymentMethodId!,
          creditCardInfo: creditCardInfo,
          billingShipingInfo: props.billingShipingInfo
        });

        if (res.error) throw new Error(res.error);

        return res.response!.data;
      }
    }),
    [props.apiInfo, props.fieldStyle, props.integrationId, props.paymentMethodId, props.billingShipingInfo]
  );

  const fields: FormFieldInfo[] = [
    {
      name: "paymentIntentId",
      Component: CreditCardInput,
      componentOpts: ccProps,
      isRequired: true,
      validation: validateCreditCard
    }
  ];

  return <FormContainer {...getRootContainerProps(props)} ref={ref} fields={fields} />;
};

export default CheckoutPaymentAuthorizeNetCreditCard;
